export enum ThreeJsNode {
  Einfassung = 'border',
  Grabsteine = 'stone',
  Platten = 'plate',
  Accessories = 'accessories'
}
